export var RenderSide;
(function (RenderSide) {
  RenderSide["front"] = "front";
  RenderSide["back"] = "back";
  RenderSide["double"] = "double";
})(RenderSide || (RenderSide = {}));
export var SubstrateType;
(function (SubstrateType) {
  SubstrateType[SubstrateType["natural"] = 0] = "natural";
  SubstrateType[SubstrateType["matte"] = 1] = "matte";
  SubstrateType[SubstrateType["kraft"] = 2] = "kraft";
  SubstrateType[SubstrateType["linen"] = 3] = "linen";
  SubstrateType[SubstrateType["pearl"] = 4] = "pearl";
  SubstrateType[SubstrateType["fabric"] = 5] = "fabric";
  SubstrateType[SubstrateType["glossy"] = 6] = "glossy";
  SubstrateType[SubstrateType["canvas"] = 7] = "canvas";
  SubstrateType[SubstrateType["wood"] = 8] = "wood";
  SubstrateType[SubstrateType["darkWood"] = 9] = "darkWood";
  SubstrateType[SubstrateType["premiumGlossy"] = 10] = "premiumGlossy";
  SubstrateType[SubstrateType["premiumMatte"] = 11] = "premiumMatte";
  SubstrateType[SubstrateType["recycledMatte"] = 12] = "recycledMatte";
  SubstrateType[SubstrateType["clearPlasticFilm"] = 13] = "clearPlasticFilm";
  SubstrateType[SubstrateType["transparent"] = 14] = "transparent";
  SubstrateType[SubstrateType["extraSoftRed"] = 15] = "extraSoftRed";
  SubstrateType[SubstrateType["metallicGold"] = 16] = "metallicGold";
  SubstrateType[SubstrateType["metallicGrey"] = 17] = "metallicGrey";
  SubstrateType[SubstrateType["metallicIceSilver"] = 18] = "metallicIceSilver";
  SubstrateType[SubstrateType["metallicIceGold"] = 19] = "metallicIceGold";
  SubstrateType[SubstrateType["clearPlastic"] = 20] = "clearPlastic";
  SubstrateType[SubstrateType["frostedPlastic"] = 21] = "frostedPlastic";
  SubstrateType[SubstrateType["cotton"] = 22] = "cotton";
})(SubstrateType || (SubstrateType = {}));